import React, { useState } from "react";
import Select from "react-select";
import { countries } from "../../../constant";
import { toast } from "react-hot-toast";
import axiosInstance from "../../../utils/axiosConfig";
import { API_URL } from "../../../constant";
import { TailSpin } from "react-loader-spinner";

interface RestrictIpModalProps {
  isOpen: boolean;
  onClose: () => void;
  setRefetch: React.Dispatch<React.SetStateAction<number>>;
}

const countryOptions = countries.map((c) => ({ value: c, label: c }));

const RestrictIpModal: React.FC<RestrictIpModalProps> = ({
  isOpen,
  onClose,
  setRefetch,
}) => {
  const [ip, setIp] = useState("");
  const [loader, setLoader] = useState(false);

  const [country, setCountry] = useState("");
  const [description, setDescription] = useState("");
  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoader(true);
    try {
      const { data: data2 } = await axiosInstance.put(
        `${API_URL}api/restricted-ips`,
        {
          ip: ip,
          reason: description,
          country: country,
        }
      );
      setRefetch((prev) => prev + 1);
      toast.success(`IP restricted successfully`);
    } catch (error: any) {
      console.log(error.response?.data?.message || "An error occurred");
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      onClose();
      setLoader(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center font-manrope justify-center bg-black bg-opacity-80">
      <div className="bg-[#1F1F1F] rounded-2xl w-full max-w-md p-8 relative shadow-lg">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-white text-xl font-bold">Restrict IP</h2>
          <button
            onClick={onClose}
            className="text-[#78C2F7] text-base font-semibold"
          >
            Close
          </button>
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-5 mt-12">
          <div>
            <label className="block text-[#AEBCC6] text-[15px] mb-2">
              Enter IP
            </label>
            <input
              type="text"
              value={ip}
              onChange={(e) => setIp(e.target.value)}
              className="w-full bg-[#1C2227] text-white rounded-lg px-4 py-3 outline-none border border-[#141414]"
              placeholder="Enter IP address"
              required
            />
          </div>
          <div>
            <label className="block text-[#AEBCC6] text-[15px] mb-2">
              Country
            </label>
            <Select
              options={countryOptions}
              value={countryOptions.find((opt) => opt.value === country)}
              onChange={(selected: { value: React.SetStateAction<string> }) =>
                setCountry(selected ? selected.value : "")
              }
              placeholder="Select country"
              classNamePrefix="react-select"
              styles={{
                control: (base: any) => ({
                  ...base,
                  backgroundColor: "#1C2227",
                  borderColor: "#141414",
                  color: "#fff",
                  minHeight: "48px",
                }),
                singleValue: (base: any) => ({
                  ...base,
                  color: "#fff",
                }),
                menu: (base: any) => ({
                  ...base,
                  backgroundColor: "#1C2227",
                  color: "#fff",
                }),
                option: (base: any, state: { isFocused: any }) => ({
                  ...base,
                  backgroundColor: state.isFocused ? "#23282D" : "#1C2227",
                  color: "#fff",
                }),
                input: (base: any) => ({
                  ...base,
                  color: "#fff",
                }),
              }}
              isSearchable
            />
          </div>
          <div>
            <label className="block text-[#AEBCC6] text-[15px] mb-2">
              Description
            </label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full bg-[#1C2227] text-white rounded-lg px-4 py-3 outline-none border border-[#141414] min-h-[120px] resize-none"
              placeholder="Enter description"
              required
            />
          </div>
          <button
            type="submit"
            disabled={ip === "" || country === "" || description === ""}
            className="w-full bg-[#1CA4F8] hover:bg-[#1890d5] flex justify-center items-center text-white font-bold py-3 rounded-lg text-lg mt-12 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loader ? (
              <TailSpin width={20} height={20} color="#fff" />
            ) : (
              "Confirm"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default RestrictIpModal;
